import { useCallback, useEffect, useState } from "react";

const KEY = "rammy_theme";
const read = () => {
  try {
    return localStorage.getItem(KEY) || "light";
  } catch {
    return "light";
  }
};

// Apply before first paint so there's no flash of the wrong canvas.
export const applyStoredTheme = () => {
  document.documentElement.setAttribute("data-theme", read());
};

export function useTheme() {
  const [theme, setTheme] = useState(read);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    try {
      localStorage.setItem(KEY, theme);
    } catch {
      /* private mode — theme just won't persist */
    }
    window.dispatchEvent(new Event("rammy-theme"));
  }, [theme]);

  useEffect(() => {
    const on = () => setTheme(read());
    window.addEventListener("rammy-theme", on);
    return () => window.removeEventListener("rammy-theme", on);
  }, []);

  const toggle = useCallback(() => {
    setTheme((t) => (t === "dark" ? "light" : "dark"));
  }, []);

  return { theme, setTheme, toggle, isDark: theme === "dark" };
}
